module.exports = __webpack_public_path__ + "media/anuan.4d635a58.wav";